import { IQuickMenuDataItem, QuickMenuDataItem } from './QuickMenuDataItem';

export interface IQuickMenuData {
    name: string;
    icon: string;
    items: IQuickMenuDataItem[];
}

export class QuickMenuData implements IQuickMenuData {
    public name: string;
    public icon: string;
    public items: IQuickMenuDataItem[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IQuickMenuData);
    constructor(obj?: any) {
        this.name = obj && obj.name || '';
        this.icon = obj && obj.icon || 'mdi-plus';
        this.items = [];
        if (obj && obj.items) {
            obj.items.forEach((item: any) => {
                this.items.push(new QuickMenuDataItem(item));
            });
        }
    }
}
